import React from 'react';
import { useTranslation } from 'react-i18next';
import r65Character from '../../../assets/images/r65-character.png';

export default function LoadingScreen() {
    const { t } = useTranslation();
    
    return (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-black text-center p-8">
            <div className="mb-6">
                <img src={r65Character} alt="R65 Character" className="mx-auto h-32 animate-bounce" />
            </div>
            
            <h2 className="text-2xl font-bold mb-4">{t('exhibitShared.loading')}</h2>
            <p className="mb-6">{t('exhibitShared.loadingMessage')}</p>
        </div>
    );
} 